import { RoutablePage, MagicConfigMixin, ContentMixin } from '@gig/magic-common';
import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Component, Mixins } from 'vue-property-decorator';

/**
 * Component displaying full static page from CMS including header and content
 */
var StaticPageComponent = /** @class */ (function (_super) {
    __extends(StaticPageComponent, _super);
    function StaticPageComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StaticPageComponent.prototype.onError = function () {
        this.routeTo({ route: RoutablePage.NOT_FOUND });
    };
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], StaticPageComponent.prototype, "slug", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], StaticPageComponent.prototype, "hideHeader", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], StaticPageComponent.prototype, "hideTitle", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], StaticPageComponent.prototype, "hideImage", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], StaticPageComponent.prototype, "hideDescription", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], StaticPageComponent.prototype, "variant", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], StaticPageComponent.prototype, "enhancedCoversOnStaticPages", void 0);
    StaticPageComponent = __decorate([
        Component({
            name: 'static-page',
        })
    ], StaticPageComponent);
    return StaticPageComponent;
}(Mixins(MagicConfigMixin, ContentMixin)));

export default StaticPageComponent;
